import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { recipientKeys } from '../queries/keys';
import { recipientPaths } from '../queries/paths';

// TSS vite/03 — KPI agregado de parcerías ("todo en general"). Endpoint REAL
// compartido (public/stats?view=kpi); acá solo se consume el bloque
// recipients_kpi. El caller lee envelope.data.recipients_kpi y valida
// envelope.available_modules.includes('recipients_kpi') — el módulo solo aparece
// cuando el rol partner del token tiene datos (MODULE_ROLE).
//
// Ojo: recipients_kpi.rates son las tasas del lado RECEPTORA (cohorte madura):
// pregnancy + survival (decisión 0041, RECIPIENT_RATE_ROWS). NO confundir la
// tasa de preñez de cohorte con la diagnosticada del informe.
export function useClientRecipientsKpi() {
    return useQuery({
        queryKey: recipientKeys.kpi(),
        queryFn: ({ signal }) =>
            api.get(recipientPaths.stats(), { params: { view: 'kpi' }, signal }).then((r) => r.data),
    });
}
